/**
 * Decides what a resolved location is allowed to do. Only a location the
 * browser itself reported may be published to the server or used to run
 * discovery queries. IP and default-center fallbacks are for viewport
 * centering only — publishing them would tell other collectors a location
 * the user never actually shared, and querying with them fabricates
 * "nearby" matches around a point that may not be true.
 */
export function canPublishAndQuery(location) {
  return location?.source === 'browser';
}
